import { motion } from 'framer-motion'; 


const TypingEffect = ({ value, duration, delay = 0 }) => {
    const characters = value.split('')
    
    return (
      <span>
        {characters.map((char, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.1,
              delay: (index * 0.1) + delay,
              ease: "easeInOut",
            }}
            style={{ display: 'inline-block', whiteSpace: 'pre' }}
          >
            {char}
          </motion.span>
        ))}
      </span>
    );
  };
  
  export default TypingEffect;
